/**
 * Multicolumn Section JS
 */

if (!customElements.get('multicolumn-section')) {
    class MulticolumnSection extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.slider = this.querySelector('[id^="Slider-"]');
            if (!this.slider) return;

            this.dotsContainer = this.querySelector('[data-dots-container]');
            if (!this.dotsContainer) return;

            this.dots = this.dotsContainer.querySelectorAll('.slider-counter__link--dots');
            this.items = this.slider.querySelectorAll('.grid__item');

            this.columnsDesktop = parseInt(this.dataset.columnsDesktop) || 3;
            this.columnsMobile = parseInt(this.dataset.columnsMobile) || 1;

            this.initDots();
        }

        initDots() {
            const updateDots = () => {
                const scrollLeft = this.slider.scrollLeft;
                const visibleCount = (window.innerWidth >= 990) ? this.columnsDesktop : this.columnsMobile;
                const item = this.items[0];
                if (!item) return;

                const itemWidth = item.offsetWidth + 15; // Including gap if any
                const currentPage = Math.round(scrollLeft / (itemWidth * visibleCount));

                this.dots.forEach((dot, index) => {
                    if (index === currentPage) {
                        dot.classList.add('slider-counter__link--active');
                    } else {
                        dot.classList.remove('slider-counter__link--active');
                    }
                });
            };

            this.dots.forEach((dot, index) => {
                dot.addEventListener('click', (e) => {
                    e.preventDefault();
                    const visibleCount = (window.innerWidth >= 990) ? this.columnsDesktop : this.columnsMobile;
                    const item = this.items[0];
                    if (!item) return;
                    const itemWidth = item.offsetWidth + 15;
                    this.slider.scrollTo({
                        left: index * itemWidth * visibleCount,
                        behavior: 'smooth'
                    });
                });
            });

            this.slider.addEventListener('scroll', updateDots, { passive: true });
            window.addEventListener('resize', updateDots);

            // Initial update
            setTimeout(updateDots, 500);
        }
    }

    customElements.define('multicolumn-section', MulticolumnSection);
}
